import { Link } from "react-router-dom";

import "./Specialities.css";

import adhd from "../../../images/specialities/adhd.png";
import autism from "../../../images/specialities/autism.png";
import depression from "../../../images/specialities/depression.png";
import personality from "../../../images/specialities/personality.png";
import ptsd from "../../../images/specialities/ptsd.png";

const Specialities = () => {
  return (
    <section className="section section-specialities position-relative">
      <div className="container-fluid">
        <div className="mb-5 section-title text-center">
          <h2>Specjalizacje</h2>
          <p className="m-0">Kompleksowa opieka nad Twoim zdrowiem psychicznym.</p>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-9">
            {/* UWAGA: brak klas Bootstrapa typu d-flex/gap-5 – układ steruje CSS (grid na desktopie, flex na mobile) */}
            <div className="specialities-slider">
              <div className="speciality-item">
                <div className="speciality-img">
                  <Link to="/oferta">
                    <img src={adhd} className="img-fluid" alt="ADHD" />
                  </Link>
                </div>
                <p>ADHD</p>
              </div>

              <div className="speciality-item">
                <div className="speciality-img">
                  <Link to="/oferta">
                    <img src={personality} className="img-fluid" alt="Zaburzenia osobowości" />
                  </Link>
                </div>
                <p>Zaburzenia osobowości</p>
              </div>

              <div className="speciality-item">
                <div className="speciality-img">
                  <Link to="/oferta">
                    <img src={autism} className="img-fluid" alt="Autyzm" />
                  </Link>
                </div>
                <p>Autyzm</p>
              </div>

              <div className="speciality-item">
                <div className="speciality-img">
                  <Link to="/oferta">
                    <img src={depression} className="img-fluid" alt="Konsultacje psychologiczne" />
                  </Link>
                </div>
                <p>Konsultacje psychologiczne</p>
              </div>

              <div className="speciality-item">
                <div className="speciality-img">
                  <Link to="/oferta">
                    <img src={ptsd} className="img-fluid" alt="Zaburzenia lękowe" />
                  </Link>
                </div>
                <p>Zaburzenia lękowe</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialities;
